var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNodoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 497.6 497.6",
    style: {
      enableBackground: "new 0 0 497.6 497.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFEE"
    },
    d: "M52.4,448c-5.6,0-5.6-7.2-5.6-12V23.2c0-4.8,0-7.2,5.6-7.2h344.8c4.8,0,9.6,2.4,9.6,7.2V436 c0,4.8-4.8,12-9.6,12H52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AA5A4"
    },
    d: "M390.8,32v400h-328V32H390.8 M397.2,0H52.4C38,0,30.8,9.6,30.8,23.2V436c0,13.6,7.2,28,21.6,28h344.8 c13.6,0,25.6-14.4,25.6-28V23.2C422.8,9.6,410.8,0,397.2,0L397.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M397.2,16H52.4c-5.6,0-5.6,2.4-5.6,7.2V436c0,3.2,0,5.6,1.6,7.2L403.6,17.6C402,16,399.6,16,397.2,16 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3BCBB"
    },
    d: "M414.8,5.6C410,1.6,403.6,0,397.2,0H52.4C38,0,30.8,9.6,30.8,23.2V436c0,8,1.6,13.6,5.6,20l26.4-25.6 V32h328v3.2L414.8,5.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFEE"
    },
    d: "M134,120h188.8c6.4,0,12-5.6,12-12s-5.6-12-12-12H134c-6.4,0-12,5.6-12,12S127.6,120,134,120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFEE"
    },
    d: "M134,184h108.8c6.4,0,12-5.6,12-12s-4.8-12-11.2-12H134c-6.4,0-12,5.6-12,12S127.6,184,134,184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFEE"
    },
    d: "M322.8,224H134c-6.4,0-12,9.6-12,16s5.6,16,12,16h188.8c6.4,0,12-9.6,12-16S330,224,322.8,224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8EFEE"
    },
    d: "M243.6,292.8H134c-6.4,0-12,5.6-12,12s5.6,12,12,12h108.8c6.4,0,12-5.6,12-12 C255.6,298.4,250,292.8,243.6,292.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1BAB9"
    },
    d: "M130,112h188.8c6.4,0,12-5.6,12-12s-5.6-12-12-12H130c-6.4,0-12,5.6-12,12S123.6,112,130,112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B1BAB9"
    },
    d: "M318.8,224H130c-6.4,0-12,5.6-12,12s5.6,12,12,12h188.8c6.4,0,12-5.6,12-12S326,224,318.8,224z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AA5A4"
    },
    d: "M239.6,288.8H130c-6.4,0-12,5.6-12,12s5.6,12,12,12h108.8c6.4,0,12-5.6,12-12 C251.6,293.6,246,288.8,239.6,288.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AA5A4"
    },
    d: "M239.6,148H130.8c-6.4,0-12,5.6-12,12s5.6,12,12,12h108.8c6.4,0,12-5.6,12-12S246,148,239.6,148z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.3,
      fill: "#9AA5A4",
      enableBackground: "new"
    },
    cx: 358.8,
    cy: 389.6,
    r: 108
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EA0A0A"
    },
    cx: 345.2,
    cy: 389.6,
    r: 108
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA0404"
    },
    d: "M345.2,281.6c60,0,108,48,108,108s-48,108-108,108"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D10909"
    },
    d: "M269.2,313.6c42.4-42.4,110.4-42.4,152.8,0s42.4,110.4,0,152.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA0404"
    },
    d: "M359.6,419.2c0,8-6.4,14.4-14.4,14.4l0,0c-8,0-14.4-6.4-14.4-14.4v-70.4c0-8,6.4-14.4,14.4-14.4l0,0 c8,0,14.4,6.4,14.4,14.4V419.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#BA0404"
    },
    cx: 345.2,
    cy: 456,
    r: 8.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M359.6,409.6c0,8-6.4,14.4-14.4,14.4l0,0c-8,0-14.4-6.4-14.4-14.4v-70.4c0-8,6.4-14.4,14.4-14.4l0,0 c8,0,14.4,6.4,14.4,14.4V409.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 345.2,
    cy: 446.4,
    r: 8.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodoc);
export default __webpack_public_path__ + "static/media/nodoc.9ad1a6e77da3fc20d59acac3059796e8.svg";
export { ForwardRef as ReactComponent };